import {ChangeDetectionStrategy, Component} from '@angular/core';


@Component({
    selector: 'technical-error',
    templateUrl: './technical-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TechnicalErrorComponent {
}
